import { useEffect } from "react";

const STORAGE_KEY = "cdss_workflow_draft_v1";

export function loadDraft() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export function clearDraft() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* storage unavailable — best-effort */
  }
}

// Autosave the workflow draft to sessionStorage whenever its serialized
// content changes (single, stable dependency).
export function useWorkflowPersistence(draft) {
  const serialized = JSON.stringify(draft);
  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, serialized);
    } catch {
      /* storage full / unavailable — best-effort */
    }
  }, [serialized]);
}
